const PageHero = ({ overline, title, subtitle, image }) => (
  <section data-testid="page-hero" className="relative bg-navy">
    {image && (
      <>
        <img
          src={image}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-navy/80" />
      </>
    )}
    <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
      {overline && (
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold mb-6">
          {overline}
        </p>
      )}
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-white max-w-4xl">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-300 max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
